import { render, staticRenderFns } from "./CallActivityProps.vue?vue&type=template&id=97179412"
import script from "./CallActivityProps.vue?vue&type=script&lang=js"
export * from "./CallActivityProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports